/**
 * Created by MINH on 9/30/2017.
 */
var ComponentClass = function () {
    this.init = function () {
        this.editor();
        // this.datetime();
        // this.fileSelect();
        this.switch();
        this.input();
        // this.price();
        // this.chart();

        this.inputTag();
        this.fileSelect();
    };

    this.editor = function () {
        let cke_conf_path = '/assets/plugins/ckeditor/';
        $('.editor-full').each(function () {
            var editor = CKEDITOR.instances[$(this).attr('id')];
            if (!editor) {
                CKEDITOR.replace($(this).attr('id'), {
                    customConfig: cke_conf_path + '/full.js'
                });
            }
        });
        $('.editor-standard').each(function () {
            var editor = CKEDITOR.instances[$(this).attr('id')];
            if (!editor) {
                if ($(this).data('inline')) {
                    CKEDITOR.inline($(this).attr('id'), {
                        disableAutoInline: true,
                        // customConfig: cke_conf_path + '/standard.js'
                    });
                } else {
                    CKEDITOR.replace($(this).attr('id'), {customConfig: cke_conf_path + '/standard.js'});
                }
            }
        });
        $('.editor-basic').each(function () {
            var editor = CKEDITOR.instances[$(this).attr('id')];
            if (!editor) {
                if ($(this).data('inline')) {
                    CKEDITOR.inline($(this).attr('id'), {
                        disableAutoInline: true,
                        customConfig: cke_conf_path + '/basic.js'
                    });
                } else {
                    CKEDITOR.replace($(this).attr('id'), {customConfig: cke_conf_path + '/basic.js'});
                }
            }
        });
    };

    this.switch = function () {
        // Multiple swithces
        let elem = Array.prototype.slice.call(document.querySelectorAll('.switch'));
        elem.forEach(function (html) {
            let switchery = new Switchery(html, {
                color: '#4099ff',
                jackColor: '#fff'
            });
        });

        let elemSmall = Array.prototype.slice.call(document.querySelectorAll('.switch-sm'));
        elemSmall.forEach(function (html) {
            let switchery = new Switchery(html, {
                color: '#4099ff',
                jackColor: '#fff',
                size: 'small'
            });
        });
    };

    this.input = function () {
        // autosize($('textarea'));
        //Initialize Select2 Elements
        $(".select2").select2({width: '100%'});

        //Flat red color scheme for iCheck
        // $('input[c-type="icheck"]').iCheck({
        //     checkboxClass: 'icheckbox_flat-blue',
        //     radioClass: 'iradio_flat-blue'
        // });

        //Input group enable
        // $(".input-group input.c-is-enable").each(function (index) {
        //     let elementId = $(this).data('element');
        //     if ($(this).is(":checked")) {
        //         $(elementId).attr('disabled', false);
        //     } else {
        //         $(elementId).attr('disabled', true);
        //     }
        //
        //     //jQuery listen for checkbox change
        //     $(this).change(function () {
        //         if (this.checked) {
        //             //I am checked
        //             $(elementId).attr('disabled', false);
        //         } else {
        //             //I'm not checked
        //             $(elementId).attr('disabled', true);
        //         }
        //     });
        //
        // })
    };

    this.inputTag = function (){
        $('input.tags').tagsinput('items');
    };

    this.price = function () {
        $("input.price").on('keyup', function () {
            let value = $(this).val();
            if (value !== "") {
                let n = parseInt(value.replace(/\D/g, ''), 10);
                $(this).val(n.toLocaleString());
            }
        });
        $("input.price").trigger('keyup');
    };

    this.datetime = function () {
        //Datetime
        $('.daterange').daterangepicker({
            "timePicker24Hour": true,
            "timePicker": true,
            "opens": "left",
            "showWeekNumbers": true,
            "showISOWeekNumbers": true,

            ranges: {
                'Hôm nay': [moment().startOf('days'), moment().endOf('days')],
                'Ngày mai': [moment().subtract(-1, 'days').startOf('days'), moment().subtract(-1, 'days').endOf('days')],
                'Tuần này': [moment().startOf('week'), moment().endOf('week')],
                'Tháng này': [moment().startOf('month'), moment().endOf('month')],
                'Tháng sau': [moment().subtract(-1, 'month').startOf('month'), moment().subtract(-1, 'month').endOf('month')]
            },
            "locale": {
                "format": "DD/MM/YYYY HH:mm",
                "separator": " - ",
                "applyLabel": "OK",
                "cancelLabel": "Hủy",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Tùy chọn",
                "weekLabel": "W",
                "daysOfWeek": [
                    "CN",
                    "T2",
                    "T3",
                    "T4",
                    "T5",
                    "T6",
                    "T7"
                ],
                "monthNames": [
                    "Tháng 1",
                    "Tháng 2",
                    "Tháng 3",
                    "Tháng 4",
                    "Tháng 5",
                    "Tháng 6",
                    "Tháng 7",
                    "Tháng 8",
                    "Tháng 9",
                    "Tháng 10",
                    "Tháng 11",
                    "Tháng 12"
                ],
                "firstDay": 1
            }
        });

        $('.datetime').daterangepicker({
            "timePicker24Hour": true,
            "timePicker": true,
            "autoApply": true,
            "showWeekNumbers": true,
            "showISOWeekNumbers": true,
            "singleDatePicker": true,
            "locale": {
                "format": "DD/MM/YYYY HH:mm",
                "applyLabel": "OK",
                "cancelLabel": "Hủy",
                "weekLabel": "W",
                "daysOfWeek": [
                    "CN",
                    "T2",
                    "T3",
                    "T4",
                    "T5",
                    "T6",
                    "T7"
                ],
                "monthNames": [
                    "Tháng 1",
                    "Tháng 2",
                    "Tháng 3",
                    "Tháng 4",
                    "Tháng 5",
                    "Tháng 6",
                    "Tháng 7",
                    "Tháng 8",
                    "Tháng 9",
                    "Tháng 10",
                    "Tháng 11",
                    "Tháng 12"
                ],
                "firstDay": 1
            }
        });

        $('.date').daterangepicker({
            "timePicker": false,
            "opens": "left",
            "autoApply": true,
            "showWeekNumbers": true,
            "showISOWeekNumbers": true,
            "singleDatePicker": true,
            "locale": {
                "format": "YYYY-MM-DD",
                "applyLabel": "OK",
                "cancelLabel": "Hủy",
                "weekLabel": "W",
                "daysOfWeek": [
                    "CN",
                    "T2",
                    "T3",
                    "T4",
                    "T5",
                    "T6",
                    "T7"
                ],
                "monthNames": [
                    "Tháng 1",
                    "Tháng 2",
                    "Tháng 3",
                    "Tháng 4",
                    "Tháng 5",
                    "Tháng 6",
                    "Tháng 7",
                    "Tháng 8",
                    "Tháng 9",
                    "Tháng 10",
                    "Tháng 11",
                    "Tháng 12"
                ],
                "firstDay": 1
            }
        });
    };

    this.fileSelect = function () {
        $(document).on('change', '.input-file-display', function (){
            let elementId = $(this).data('id');
            if($(this).is(":checked")){
                $(`#${elementId}`).show();
            }else{
                $(`#${elementId}`).hide();
            }
        });

        $(document).on('click', '.ckfinder-file-select', function () {
            let inputID = $(this).data('input');
            let previewID = $(this).data('preview');
            let type = $(this).data('type');

            let $targetInput = $(`#${inputID}`);
            let $targetPreview = $(`#${previewID}`);
            CKFinder.modal({
                chooseFiles: true,
                width: 800,
                height: 600,
                onInit: function (finder) {
                    finder.on('files:choose', function (evt) {
                        switch (type) {
                            case 'gallery':
                                //old data
                                let gallery = [];
                                if ($targetInput.val()) {
                                    gallery = JSON.parse($targetInput.val());
                                }
                                console.log(gallery);

                                let files = evt.data.files;
                                files.forEach(function (file, i) {
                                    let image = file.getUrl();
                                    gallery.push(image);
                                    //render
                                    $targetPreview.append(
                                        $('<div class="gallery-preview__item">').append(
                                            $('<a class="close">').data('value', image).data('input', inputID).append('×'),
                                            $('<img>').attr('src', image)
                                        )
                                    );
                                });

                                //set to input
                                $targetInput.val(JSON.stringify(gallery)).trigger('change');
                                $targetPreview.trigger('change');

                                break;
                            default:
                                let file = evt.data.files.first();
                                $targetInput.val(file.getUrl()).trigger('change');
                                $targetPreview.attr('src', file.getUrl()).trigger('change');
                                break;
                        }
                    });

                    finder.on('file:choose:resizedImage', function (evt) {
                        let image = evt.data.resizedUrl;
                        switch (type) {
                            case 'gallery':
                                //old data
                                let gallery = [];
                                if ($targetInput.val()) {
                                    gallery = JSON.parse($targetInput.val());
                                }
                                gallery.push(image);
                                //render
                                $targetPreview.append(
                                    $('<div class="gallery-preview__item">').append(
                                        $('<a class="close">').data('value', image).data('input', inputID).append('×'),
                                        $('<img>').attr('src', image)
                                    )
                                );

                                //set to input
                                $targetInput.val(JSON.stringify(gallery)).trigger('change');
                                $targetPreview.trigger('change');
                                break;
                            default:
                                $targetInput.val(image).trigger('change');
                                $targetPreview.attr('src', image).trigger('change');
                        }
                    });
                }
            });
        });

        $(document).on('click', '.gallery-preview__item a.close', function () {
            let $targetInput = $('#' + $(this).data('input'));
            let $galleryPreview = $(this).closest('.gallery-preview');
            let $galleryPreviewItem = $(this).closest('.gallery-preview__item');

            let index = $galleryPreview.children().index($galleryPreviewItem);
            console.log(index);

            //remove input
            let value = JSON.parse($targetInput.val());
            value.splice(index, 1);
            $targetInput.val(JSON.stringify(value));

            //remove gallery item
            $galleryPreviewItem.remove();
        });
    };

    this.chart = function () {
        /* SPARKLINE CHARTS
   * ----------------
   * Create a inline charts with spark line
   */

        // -----------------
        // - SPARKLINE BAR -
        // -----------------
        $('.sparkbar').each(function () {
            var $this = $(this);
            $this.sparkline('html', {
                type: 'bar',
                height: $this.data('height') ? $this.data('height') : '30',
                barColor: $this.data('color')
            });
        });

        // -----------------
        // - SPARKLINE PIE -
        // -----------------
        $('.sparkpie').each(function () {
            var $this = $(this);
            $this.sparkline('html', {
                type: 'pie',
                height: $this.data('height') ? $this.data('height') : '90',
                sliceColors: $this.data('color')
            });
        });

        // ------------------
        // - SPARKLINE LINE -
        // ------------------
        $('.sparkline').each(function () {
            var $this = $(this);
            $this.sparkline('html', {
                type: 'line',
                height: $this.data('height') ? $this.data('height') : '90',
                width: '100%',
                lineColor: $this.data('linecolor'),
                fillColor: $this.data('fillcolor'),
                spotColor: $this.data('spotcolor')
            });
        });
    };

    this.disableButton = function ($btn) {
        let isDisabled = $btn.prop('disabled');
        if (!isDisabled) {
            $btn.prop('disabled', true);
            $btn.attr('data-html', $btn.html());
            $btn.html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>`);
        }
    };
    this.enableButton = function ($btn) {
        let isDisabled = $btn.prop('disabled');
        if (isDisabled) {
            $btn.prop('disabled', false);
            $btn.html($btn.data('html'));
        }
    };
};
Component = new ComponentClass();

$(document).ready(function () {
    Component.init();

    var staying_in_site = false;
    $("[data-alert='onchange']").change(function () {
        staying_in_site = true;
    });
    $("button[type='submit']").click(function () {
        staying_in_site = false;
    });
    window.onbeforeunload = function (e) {
        if (staying_in_site) {
            return "Changes you made may not be saved. Leave site?";
        }
    };

});
